import { EProjectSection, trackEventV2 } from '../trackEventV2';
import { ENavClickedEventName, INavClickedEvent } from './types';

export function trackNavClickedEvent(event: INavClickedEvent) {
  trackEventV2(ENavClickedEventName.NAV_CLICKED, EProjectSection.MARKETPLACE, {
    ...event,
  });
}
